// Données de navigation pour les signes du zodiaque
export const zodiacNavItems = [
  {
    title: 'Bélier',
    image: '/images/signes/belier.webp',
    url: '/blog/signes/belier'
  },
  {
    title: 'Taureau',
    image: '/images/signes/taureau.webp',
    url: '/blog/signes/taureau'
  },
  {
    title: 'Gémeaux',
    image: '/images/signes/gemeaux.webp',
    url: '/blog/signes/gemeaux'
  },
  {
    title: 'Cancer',
    image: '/images/signes/cancer.webp',
    url: '/blog/signes/cancer'
  },
  {
    title: 'Lion',
    image: '/images/signes/lion.webp',
    url: '/blog/signes/lion'
  },
  {
    title: 'Vierge',
    image: '/images/signes/vierge.webp',
    url: '/blog/signes/vierge'
  },
  {
    title: 'Balance',
    image: '/images/signes/balance.webp',
    url: '/blog/signes/balance'
  },
  {
    title: 'Scorpion',
    image: '/images/signes/scorpion.webp',
    url: '/blog/signes/scorpion'
  },
  {
    title: 'Sagittaire',
    image: '/images/signes/sagittaire.webp',
    url: '/blog/signes/sagittaire'
  },
  {
    title: 'Capricorne',
    image: '/images/signes/capricorne.webp',
    url: '/blog/signes/capricorne'
  },
  {
    title: 'Verseau',
    image: '/images/signes/verseau.webp',
    url: '/blog/signes/verseau'
  },
  {
    title: 'Poissons',
    image: '/images/signes/poissons.webp',
    url: '/blog/signes/poissons'
  }
]; 